import { useEffect, useRef } from "react";
import { ColumnDefinition } from "../Table.definition";
import styles from "../Table.module.scss";

type TableSeparatorProps<T> = {
  columns: ColumnDefinition<T>[];
  selectable?: boolean;
};
export function TableSeparator<T>({
  columns,
  selectable,
}: TableSeparatorProps<T>) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.style.setProperty(
        "--span-columns",
        String(columns.length + (selectable ? 1 : 0))
      );
    }
  }, [columns.length, selectable]);

  return <div ref={divRef} className={styles.separator} />;
}
